import { useCallback } from 'react';
import { segment } from '@actions/analytics';
import constants, { LOGIN_OTP_REQUESTED } from '@cont/Login/constants';
import validatePresetRedirectURL from '@utils/validateRedirectUrl';
import segmentStorage from '@events/segmentStorage';
import useLoginExperimentEventProps from '@hooks/segment/useLoginExperimentEventProps';

const useLogOTPRequestedEvent = ({ loginType, presetRedirectURL, source }) => {
  const experimentData = useLoginExperimentEventProps(source);
  return useCallback(
    (result) => {
      if (!result) return;
      segment.track(LOGIN_OTP_REQUESTED, {
        ...(experimentData || {}),
        is_new_user: !(result.is_registered ?? true),
        resend: false,
        login_medium:
          loginType === constants.LOGIN_TYPE_NUMBER ? 'Mobile' : 'Email',
        login_primary_source: segmentStorage.getItem('lps'),
        last_primary_source_section: segmentStorage.getItem('lpss') || 'NA',
        redirect_to: validatePresetRedirectURL(presetRedirectURL) || 'NA'
      });
    },
    [loginType, presetRedirectURL, experimentData]
  );
};

export default useLogOTPRequestedEvent;
